import { KioskDistributionModel } from 'api/dto/KioskDistribution.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'kioskDistribution';

export namespace KioskDistributionState {
  export type Domain = {
    distributionResource?: Resource<KioskDistributionModel>;
  };

  export const INITIAL_DOMAIN: Domain = {
    distributionResource: Resource.createPendingResource<KioskDistributionModel>(),
  };
}
